/**
 * LUMEN Mega Menu — lumen-mega-menu.js
 * - 모바일 드로어 열기/닫기 (햄버거 버튼 연동)
 * - 탭 전환 (SHOP / COLLECTION / STORY / INFO)
 * - 검색 패널 열기/닫기 (검색 아이콘 연동)
 */

(function () {
  'use strict';

  const DRAWER_ID = 'LumenMobileDrawer';
  const BACKDROP_ID = 'LumenMobileBackdrop';
  const SEARCH_ID = 'LumenMobileSearch';
  const OPEN_CLASS = 'lmm-mobile-drawer--open';
  const SEARCH_CLASS = 'lmm-mobile-search--open';
  const TAB_ACTIVE = 'lmm-mobile-drawer__tab--active';
  const PANEL_ACTIVE = 'lmm-mobile-drawer__tab-panel--active';

  // 요소들
  const drawer = document.getElementById(DRAWER_ID);
  const backdrop = document.getElementById(BACKDROP_ID);
  const search = document.getElementById(SEARCH_ID);

  if (!drawer) return;

  // ── 드로어 열기/닫기 ──────────────────────────────────────
  function openDrawer() {
    drawer.classList.add(OPEN_CLASS);
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove(OPEN_CLASS);
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    // 검색 패널도 닫기
    if (search) {
      search.classList.remove(SEARCH_CLASS);
      search.setAttribute('aria-hidden', 'true');
    }
  }

  // 배경 클릭 시 닫기
  if (backdrop) {
    backdrop.addEventListener('click', closeDrawer);
  }

  // ESC 키
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains(OPEN_CLASS)) {
      closeDrawer();
    }
  });

  // ── 햄버거 버튼 연결 ─────────────────────────────────────
  // header.liquid 의 .header__icon--menu (Dawn 기본) 또는 커스텀 버튼
  function bindMenuToggle() {
    // Dawn 기본 햄버거 버튼 selector
    const toggleBtns = document.querySelectorAll('.header__icon--menu, [data-lmm-open], #LumenMenuToggle');
    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        // 모바일에서만 동작
        if (window.innerWidth > 768) return;
        e.preventDefault();
        if (drawer.classList.contains(OPEN_CLASS)) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
    });
  }

  // ── 검색 버튼 연결 ───────────────────────────────────────
  function bindSearchToggle() {
    const searchBtns = document.querySelectorAll('.header__icon--search, [data-lmm-search], #LumenSearchToggle');
    searchBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (window.innerWidth > 768) return;
        e.preventDefault();
        if (!drawer.classList.contains(OPEN_CLASS)) {
          openDrawer();
        }
        if (search) {
          search.classList.add(SEARCH_CLASS);
          search.setAttribute('aria-hidden', 'false');
          // 검색 인풋 포커스
          const input = document.getElementById('LumenMobileSearchInput');
          if (input) {
            setTimeout(function () {
              input.focus();
            }, 200);
          }
        }
      });
    });
  }

  // ── 탭 전환 ──────────────────────────────────────────────
  function initTabs() {
    const tabs = drawer.querySelectorAll('.lmm-mobile-drawer__tab');
    const panels = drawer.querySelectorAll('.lmm-mobile-drawer__tab-panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const handle = tab.dataset.tab;

        // 탭 active 토글
        tabs.forEach(function (t) {
          t.classList.remove(TAB_ACTIVE);
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add(TAB_ACTIVE);
        tab.setAttribute('aria-selected', 'true');

        // 패널 active 토글
        panels.forEach(function (p) {
          p.classList.remove(PANEL_ACTIVE);
        });
        const target = document.getElementById('LumenMobileTab-' + handle);
        if (target) {
          target.classList.add(PANEL_ACTIVE);
        }

        // 검색 패널 닫기
        if (search) {
          search.classList.remove(SEARCH_CLASS);
          search.setAttribute('aria-hidden', 'true');
        }

        // 스크롤 맨 위로
        const tabPanels = drawer.querySelector('.lmm-mobile-drawer__tab-panels');
        if (tabPanels) tabPanels.scrollTop = 0;
      });
    });
  }

  // ── 초기화 ───────────────────────────────────────────────
  function init() {
    bindMenuToggle();
    bindSearchToggle();
    initTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
